/**
 * Отметка «Выключить на этом устройстве» мобильной версии (specs/006 FR-012; ключ `pushKeys.off`
 * из `src/mobile/services/push.ts`). Устройство одно на обе версии, поэтому полная версия её
 * соблюдает: не подписывает устройство тихо, а «Включить» на её плашке отметку снимает.
 */

export const PUSH_OFF_KEY = "rost.push.off";

/** Push выключен на этом устройстве; хранилище недоступно — не выключен */
export function pushOffHere(): boolean {
    try {
        return localStorage.getItem(PUSH_OFF_KEY) === "1";
    } catch {
        return false;
    }
}

/** «Включить»: отметка выключения снимается */
export function clearPushOff(): void {
    try {
        localStorage.removeItem(PUSH_OFF_KEY);
    } catch {
        // хранилище недоступно — отметки нет
    }
}

/**
 * Подписка сделана с другим ключом сервера (ключи VAPID заменили) — служба доставки её больше
 * не примет, а `subscribe` с новым ключом поверх неё падает. Ключ неизвестен — считаем тем же.
 */
export function hasOtherKey(
    subscription: { options?: { applicationServerKey: ArrayBuffer | null } },
    key: Uint8Array
): boolean {
    const current = subscription.options?.applicationServerKey;

    if (!current) {
        return false;
    }

    const bytes = new Uint8Array(current);

    return bytes.length !== key.length || bytes.some((value, i) => value !== key[i]);
}
